import React, { FC } from "react";
import layoutStyles from "./childrenModeGreetingLayout.module.scss";
import styles from "./ChildrenModeSpaceGreeting.module.scss";

type ChildrenModeSpaceGreetingProps = {
  title: string;
  subTitle: string;
};

export const ChildrenModeSpaceGreeting: FC<ChildrenModeSpaceGreetingProps> = ({
  title,
  subTitle,
}) => (
  <div className={layoutStyles.root}>
    <p className={styles.text}>{title}</p>
    <p className={styles.text}>{subTitle}</p>
  </div>
);
